// extracted by mini-css-extract-plugin
export var button = "_e2-4";
export var hasDarkBackground = "_e2-7";
export var hasLightBackground = "_e2-6";
export var iconWrapper = "_e2-0";
export var large = "_e2-2";
export var medium = "_e2-1";
export var small = "_e2-5";
export var xsmall = "_e2-3";